module.exports = "/settings/components/shiftAlarms/shiftAlarmRowComponent-560b3d.html";